import { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import SelectField from "../../Shared/SelectField";
import {years_list, months_list} from "../../Shared/List";

const SubPayPayroll = (props) => {
    const current_user = JSON.parse(localStorage.getItem('user'))
    const billing_date  = current_user?.branch?.billing_date
    const [yearOptions, setYearOptions] = useState([])
    const [monthOptions, setMonthOptions] = useState([])

    const navigate = useNavigate()

    const [formData, setFormData] = useState({
        year: billing_date.year,
        month: billing_date.month,
    })
    const {year, month} = formData


    useEffect(() => {
        const years = []
        const months = []
        years_list.map(year => (
            years.push({
                id: year.id,
                key: year.key,
                name: year.name
            })
        ))
        
        months_list.map(month => (
            months.push({
                id: month.id,
                key: month.key,
                name: month.name
            })
        ))

        setYearOptions(years)
        setMonthOptions(months)
    }, [])

    const onChange = (e) => {
        setFormData((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value
        }))
    }

    const onSubmit = (e) => {
        e.preventDefault()
        
        const payload = {year, month}
        navigate('/pay-payroll', {state: {payload: payload}})
        
    }

  return (
    <>
        <div className="card">
    
            <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
                <h3 className="card-title">Sub PayPayroll Form</h3>
            </div>
            <div className="card-body">
                <form onSubmit={onSubmit}>
                    <div className="row">
                        <div className="col-md-6">
                            <SelectField
                                name="year"
                                label="Year"
                                value={parseInt(year)}
                                options={yearOptions}
                                onChange={onChange}
                            />
                        </div>
                        <div className="col-md-6">
                            <SelectField
                                name="month"
                                label="Month"
                                value={parseInt(month)}
                                options={monthOptions}
                                onChange={onChange}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <input type="submit" className="btn btn-info" value="Next" style={{float: 'right'}}/>
                        </div>
                    </div>
                    <br/>
                </form>
            </div>
        </div>
      <br/>
    </>
  )
}

export default SubPayPayroll